import { SatelliteJob } from "@nova/protobuf"
import { entityValidator, enumValidator, UnionToTuple } from "../util"
import { JobStatusType } from "@nova/constants"
import { dateAsNumber } from "../../util"

export const createSatelliteJobValidator = entityValidator(SatelliteJob, {})

export const updateSatelliteJobValidator = entityValidator(SatelliteJob, {
    status: {
        validators: enumValidator("status", JobStatusType),
        nonNull: true,
    },
    progress: {
        validators: [
            {
                validator: (progress) => progress >= 0 && progress <= 100,
                error: "Progress is out of range",
            },
        ],
    },
    error: {
        validators: [],
    },
    updatedAt: {
        validators: [],
    },
})

export const getDefaultSatelliteJobCreateArgs = () => ({
    createdAt: dateAsNumber(),
    status: JobStatusType.QUEUED,
})

export type CreateSatelliteJobArgs = UnionToTuple<keyof typeof createSatelliteJobValidator>
export type UpdateSatelliteJobArgs = UnionToTuple<keyof typeof updateSatelliteJobValidator>
